import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {IpRule} from '../../../../../models/ip-rule';
import {Paginator} from '../../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../../tools/table-sorter/table-sorter';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {SnackbarService} from '../../../../../services/snackbar/snackbar.service';
import {IpRuleService} from '../../../../../services/ip-rule/ip-rule.service';
import {ConfirmDirective} from '../../../../../directives/confirm/confirm.directive';
import {IsGrantedDirective} from '../../../../../directives/is-granted/is-granted.directive';
import { NgClass, NgOptimizedImage } from '@angular/common';
import {PaginatorComponent} from '../../../../layout/paginator/paginator.component';
import {RouterLink} from '@angular/router';
import {IsGranted} from '../../../../../decorator/is-granted';
import {MetaTitle} from '../../../../../decorator/meta-title';
import {CountryService} from '../../../../../services/country/country.service';

@Component({
  selector: 'app-ip-rule-list',
  imports: [
    ConfirmDirective,
    IsGrantedDirective,
    PaginatorComponent,
    RouterLink,
    NgOptimizedImage,
    NgClass
],
  templateUrl: './ip-rule-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ip-rule-list.component.scss'
})
@IsGranted(['IP_RULE_VIEW'])
@MetaTitle('IP rules')
export class IpRuleListComponent implements OnInit {
  ipRules: IpRule[] = [];
  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('position', 'asc');

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private ipRuleService: IpRuleService,
    protected countryService: CountryService
  ) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();

    this.ipRuleService.findAll({}, this.paginator, this.tableSorter).subscribe((ipRules) => {
      this.ipRules = ipRules;

      this.loader.stopLoading();
    })
  }

  delete(ipRule: IpRule): void {
    if (ipRule.id) {
      this.loader.startLoading();
      this.ipRuleService.delete(ipRule.id).subscribe(() => {
        this.loader.stopLoading();
        this.snackbar.success('IP rule has been deleted');
        this.refresh();
      });
    }
  }

  up(ipRule: IpRule): void {
    this.ipRuleService.up(ipRule).subscribe(() => {
      this.refresh();
    });
  }

  down(ipRule: IpRule): void {
    this.ipRuleService.down(ipRule).subscribe(() => {
      this.refresh();
    });
  }
}
